import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SuccessConfig {
  content: string;
  action?: string;
  subtitle?: string;
  emoji?: string;
}

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SuccessDialogComponent {
  content: string;
  action: string;
  subtitle: string;
  emoji: string;

  constructor(
    public dialogRef: MatDialogRef<SuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SuccessConfig,
  ) {
    this.content = data.content;
    this.action = data.action || 'OK';
    this.subtitle = data.subtitle || '';
    this.emoji = data.emoji || '';
  }
}
